import { render, staticRenderFns } from "./Beltties.vue?vue&type=template&id=5e18f79a&scoped=true&"
import script from "./Beltties.vue?vue&type=script&lang=js&"
export * from "./Beltties.vue?vue&type=script&lang=js&"
import style0 from "./Beltties.vue?vue&type=style&index=0&id=5e18f79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e18f79a",
  null
  
)

export default component.exports